import React from "react";
import { Block } from "baseui/block";
import { StyledLink } from "baseui/link";
import Alert from "baseui/icon/alert";
import { useStyletron } from "baseui";
import { Banner, KIND, HIERARCHY } from "baseui/banner";
import { LabelLarge } from "baseui/typography";
const RestrictedAccessAlert = () => {
  const [css, theme] = useStyletron();
  return (
    <Block
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%" // Ensures full height of the container for proper centering
      width="100%" // Full width for centering
      backgroundColor="rgba(255, 255, 255, 0.8)" // Semi-transparent white background
    >
      <Alert size="105px" color={theme.colors.warning} />
      <Block
        marginTop="scale300" // Space above the text
        marginBottom="scale300" // Space below the text before the link
        color="#333" // Text color
        $style={{ textAlign: "center" }}
      >
        <Banner
          title="Access Restricted"
          hierarchy={HIERARCHY.high}
          kind={KIND.warning}
        >
          <LabelLarge>Free users don't have access to this feature.</LabelLarge>
        </Banner>
      </Block>
      <StyledLink
        href="account/billing"
        style={{ fontSize: "18px", fontWeight: "500" }}
      >
        Subscribe Here
      </StyledLink>
    </Block>
  );
};

export default RestrictedAccessAlert;
